export default {
  items: (state) => state.items,
};
